import Layout from '../../views/layouts/index'
const courseRouter = {
  path: '/',
  component: Layout,
  redirect: '/answer',
  alwaysShow: true,
  name: 'course',
  children: [
    {
      path: 'answer',
      component: () => import('../../views/answerQuestion/index'),
      name:'answer'
    },
    {
      path: 'answer/detail/index',
      component: () => import('../../views/answerQuestion/detail'),
      name:'detail_index'
    },
    {
      path: 'answer/expert/list',
      component: () => import('../../views/answerQuestion/expert/list'),
      name:'expert_list',
      meta:{activeMenu:'/answer'}
    },
    {
      path: 'answer/expert/home',
      component: () => import('../../views/answerQuestion/expert/home'),
      name:'expert_home',
      meta:{activeMenu:'/answer'}
    },
    {
      path: 'answer/expert/expert_question',
      component: () => import('../../views/answerQuestion/expert/homeQuestion'),
      name:'expert_question',
      meta:{activeMenu:'/answer'}
    },
    {
      path: 'answer/expert/rate',
      component: () => import('../../views/answerQuestion/expert/rate'),
      name:'expert_rate',
      meta:{activeMenu:'/answer'}
    },
    {
      path: 'answer/release',
      component: () => import('../../views/answerQuestion/release'),
      name:'answer_release',
      meta:{activeMenu:'/answer'}
    },
    {
      path: 'answer/my',
      component: () => import('../../views/answerQuestion/expert/answer'),
      name:'my_answer',
      meta:{activeMenu:'/answer'}
    },
    {
      path: 'answer/my/question',
      component: () => import('../../views/answerQuestion/my/question'),
      name:'my_question',
      meta:{activeMenu:'/answer'}
    },
    {
      path: 'answer/my/question/detail',
      component: () => import('../../views/answerQuestion/my/detail'),
      name:'my_question_detail',
      meta:{activeMenu:'/answer'}
    },
    {
      path: 'answer/detail',
      component: () => import('../../views/answerQuestion/expert/detail'),
      name:'answer_detail',
      meta:{activeMenu:'/answer'}
    }
  ]
}

export default courseRouter



// WEBPACK FOOTER //
// ./src/router/modules/answer.js